var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 21.470703 8.9863281 A 1.50015 1.50015 0 0 0 20.439453 9.4394531 L 6.4394531 23.439453 A 1.50015 1.50015 0 0 0 6.4394531 25.560547 L 20.439453 39.560547 A 1.50015 1.50015 0 1 0 22.560547 37.439453 L 11.121094 26 L 40.5 26 A 1.50015 1.50015 0 1 0 40.5 23 L 11.121094 23 L 22.560547 11.560547 A 1.50015 1.50015 0 0 0 21.470703 8.9863281 z"}));
}

ArrowLeft.defaultProps = {"fill":"#000000","viewBox":"0 0 48 48","width":"24px","height":"24px"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
